import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('jwt_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Only log critical errors (not 401 auth errors during normal flow)
    if (error.response?.status !== 401) {
      console.error(`[API ERROR] ${error.config?.method?.toUpperCase()} ${error.config?.url} - Status: ${error.response?.status}`);
      console.error('[API ERROR DATA]', error.response?.data);
    }
    
    if (error.response?.status === 401) {
      // Only trigger logout if we had a token (meaning we were authenticated)
      const hadToken = sessionStorage.getItem('jwt_token');
      if (hadToken) {
        // Clear tokens and trigger Auth0 logout
        sessionStorage.removeItem('jwt_token');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Trigger Auth0 logout by dispatching a custom event
        window.dispatchEvent(new CustomEvent('auth-logout'));
      }
    }
    return Promise.reject(error);
  }
);

export default api;
